module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Billing Reports ")])], 1), _vm._v(" "), _c('div', [_c('b-card', {
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "pills": "",
      "card": "",
      "vertical": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "active": "",
      "title": "TPT Trucking Analysis Report"
    }
  }, [_c('b-card-text', {
    staticClass: "mt-3"
  }, [_c('b-row', {
    staticClass: "mt-4 justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inline-form-custom-select-pref"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inline-form-custom-select-pref"
    }
  }, [_vm._v("Date Range")]), _c('date-range-picker', {
    ref: "picker",
    attrs: {
      "always-show-calendars": _vm.showCal,
      "opens": "right",
      "locale-data": _vm.locale
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return _c('div', {}, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(_vm.dateRange.startDate)) + " -\n                        " + _vm._s(_vm._f("moment")(_vm.dateRange.endDate)) + "\n                      ")])
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4 justify-content-center"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "8"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.getReports('TRUCKING_ANALYSIS_REPORT')
      }
    }
  }, [_vm._v("TPT Trucking Analysis Report")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.username == 'Bhavneesh') ? _c('b-tab', {
    attrs: {
      "active": "",
      "title": "Credit Debit Notes Report"
    }
  }, [_c('b-card-text', {
    staticClass: "mt-3"
  }, [_c('b-row', {
    staticClass: "mt-2 justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "inline-form-custom-select-pref"
    }
  }, [_vm._v("Date Range")]), _c('date-range-picker', {
    ref: "picker",
    attrs: {
      "always-show-calendars": _vm.showCal2,
      "opens": "right",
      "locale-data": _vm.locale
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return _c('div', {}, [_vm._v("\n                        " + _vm._s(_vm._f("moment")(_vm.dateRange2.startDate)) + " -\n                        " + _vm._s(_vm._f("moment")(_vm.dateRange2.endDate)) + "\n                      ")])
      }
    }]),
    model: {
      value: (_vm.dateRange2),
      callback: function($$v) {
        _vm.dateRange2 = $$v
      },
      expression: "dateRange2"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-4 justify-content-center"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "8"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.getCreditDebitReports()
      }
    }
  }, [_vm._v("Credit Debit Notes Report ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "PopDoc",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbd098a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/reports/newBillingReports.vue
// module id = 2602
// module chunks = 0